import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Box,
  Typography,
  TextField,
  Button,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";

import EditIcon from "../../../images/editpencil.svg";
import BaseCustomerTable from "../../BaseCustomerTable/BaseCustomerTable";
import { commonRunQuery } from "../../../util/API/loans";
import { setAsArray } from "../../../util/utilfunctions/utilFunctions";
import { addUpdateExchangeRate } from "../../../util/API/admin";

export default function ExchangeFeeModule() {
    const [formData, setFormData] = useState({
        sourcecurrency: "",
        destinationcurrency: "",
        rate: "",
        active: true,
    });

    const [exchangeRates, setExchangeRates] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [historyPage, setHistoryPage] = useState(0);
    const [historyRowsPerPage, setHistoryRowsPerPage] = useState(5);
    const [open, setOpen] = useState(false);
    const [selectedRate, setSelectedRate] = useState(null);
    const [editingRowId, setEditingRowId] = useState(null);
    const [editedData, setEditedData] = useState({});
    const [historyData, setHistoryData] = useState([]);
    const [showHistory, setShowHistory] = useState(false);
    const [selectedSrcCurr, setSelectedSrcCurr] = useState(null);
    const [selectedDestCurr, setSelectedDestCurr] = useState(null);

    const user = useSelector((state) => state.login.user);
    const dispatch = useDispatch();


    useEffect(() => {
        getExchangeRates();
    }, []);

  
    const getExchangeRates = async () => {
        const response = await commonRunQuery(324, "");
      
        if (
          response?.data?.header?.callStatus === "1" &&
          response?.data?.header?.reccount > 0
        ) {
          const records = setAsArray(response?.data?.body?.record);
      
          // 🔹 Transform to simple flat structure
          const formatted = records.map((item) => {
            const rate = item.exchangerate;
            return {
              id: rate.recid,
              sourcecurrency: rate.sourcecurrency,
              destinationcurrency: rate.destinationcurrency,
              rate: parseFloat(rate.rate).toFixed(2), // 58.75 instead of 58.7500
              active: rate.active === "1", // convert to boolean
              lastupdatedate: rate.lastupdatedate,
              lastupdateby: rate.lastupdateby,
            };
          });
      
          console.log("Formatted Exchange Rates:", formatted);
          setExchangeRates(formatted);
        } else {
          setExchangeRates([]); // in case of no data
        }
    };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData({
            ...formData,
            [name]: type === "checkbox" ? checked : value,
        });
    };

    const handleSubmit = async(e) => {
        e.preventDefault();
        console.log("user============",user?.id);
        console.log("formData============",formData);

        const response = await addUpdateExchangeRate(formData?.sourcecurrency, formData?.destinationcurrency, formData?.rate, formData?.active == true ? 1 : 0, user?.id);
        console.log("handleSubmit_response-----------", response);
        if(response?.data?.header?.callStatus == "1") {
            getExchangeRates();
            setFormData({
                sourcecurrency: "",
                destinationcurrency: "",
                rate: "",
                active: true,
            });
        }

        // const newRate = {
        //     id: exchangeRates.length + 1,
        //     ...formData,
        //     rate: parseFloat(formData.rate),
        // };

        // setExchangeRates([...exchangeRates, newRate]);
        setFormData({
            sourcecurrency: "",
            destinationcurrency: "",
            rate: "",
            active: true,
        });
    };

    const toggleActive = (id) => {
        setExchangeRates((prev) =>
        prev.map((item) =>
            item.id === id ? { ...item, active: !item.active } : item
        ));
    };

    const pageCount = Math.ceil(exchangeRates.length / rowsPerPage);
    const pageNumbers = Array.from({ length: pageCount }, (_, index) => index);
    
    const handleChangePage = (event, newPage) => {
        console.log("New Page:", newPage);
        setPage(newPage);
    };

    const startEditing = (row) => {
        setEditingRowId(row.id);
        setEditedData({ ...row }); // Pre-fill inputs with current row data
    };
      
    // Handle update click
    const handleUpdate = async (id) => {
            console.log("Updating record:", editedData);
      
        // Call your existing API
        const response = await addUpdateExchangeRate(
            editedData.sourcecurrency,
            editedData.destinationcurrency,
            editedData.rate,
            editedData.active ? 1 : 0,
            user?.id
        );
      
        if (response?.data?.header?.callStatus === "1") {
            // Refresh list
            await getExchangeRates();
            setEditingRowId(null);
            setEditedData({});
        } else {
            console.error("Failed to update exchange rate");
        }
    };

    const handleViewHistory = async (rowData) => {
        try {
            setShowHistory(true);
            const response = await commonRunQuery(327, `${rowData?.sourcecurrency}/${rowData?.destinationcurrency}`);
            if(response?.data?.header?.callStatus == "1" && parseInt(response?.data?.header?.reccount) > 0 ) {
                let records = response?.data?.body?.record;
                records = setAsArray(records);
                const formattedHistory = records.map((item) => {
                    const hist = item.exchangeratehistory;
                    console.log("hist------",hist);
                    return {
                        recdate: hist.recdate,
                        sourcecurrency: hist.sourcecurrency,
                        destinationcurrency: hist.destinationcurrency,
                        rate: parseFloat(hist.rate).toFixed(2),
                        lastupdateby: hist.lastupdateby,
                        lastupdateemail: item?.useremailaccount?.lastupdateemail
                    };
                });
                setHistoryData(formattedHistory);
                console.log("handleViewHistory_response-------",formattedHistory);
            } else {
                setHistoryData([]);
            }

        } catch (error) {
            console.log("handleViewHistory_error---------",error);
        }
    }

    const handleBack = () => {
        setShowHistory(false);
        setHistoryData([]);
        setSelectedSrcCurr(null);
        setSelectedDestCurr(null);
    };

    return (
        <Box >
            {!showHistory ? (
                <>
                    <Typography variant="h6" sx={{ mb: 2 }}>
                        Exchange Rate Management
                    </Typography>

                    {/* ----------- FORM ----------- */}
                    <Box
                        component="form"
                        onSubmit={handleSubmit}
                        sx={{
                        display: "flex",
                        gap: 2,
                        flexWrap: "wrap",
                        mb: 3,
                        alignItems: "center",
                        }}
                    >
                        <TextField
                            label="Source Currency"
                            name="sourcecurrency"
                            value={formData.sourcecurrency}
                            onChange={handleChange}
                            required
                        />
                        <TextField
                            label="Destination Currency"
                            name="destinationcurrency"
                            value={formData.destinationcurrency}
                            onChange={handleChange}
                            required
                        />
                        <TextField
                            label="Exchange Rate"
                            name="rate"
                            type="number"
                            value={formData.rate}
                            onChange={handleChange}
                            required
                        />
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                            <Typography sx={{ mr: 1 }}>Active</Typography>
                            <Switch
                                name="active"
                                checked={formData.active}
                                onChange={handleChange}
                            />
                        </Box>
                        <Button type="submit" variant="contained">
                            Add Exchange Rate
                        </Button>
                    </Box>

                    {/* ----------- TABLE ----------- */}
                    <TableContainer component={Paper} sx={{ boxShadow: "none" }}>
                        <Table sx={{ minWidth: 500 }} aria-label="exchange rate table">
                            <TableHead>
                                <TableRow>
                                <TableCell align="left">
                                    <Typography className="customer-table-headers">
                                    Source Currency
                                    </Typography>
                                </TableCell>
                                <TableCell align="left">
                                    <Typography className="customer-table-headers">
                                    Destination Currency
                                    </Typography>
                                </TableCell>
                                <TableCell align="left">
                                    <Typography className="customer-table-headers">Rate</Typography>
                                </TableCell>
                                <TableCell align="left">
                                    <Typography className="customer-table-headers">
                                    Active
                                    </Typography>
                                </TableCell>
                                <TableCell align="left">
                                    <Typography className="customer-table-headers">Actions</Typography>
                                </TableCell>
                                {/* <TableCell align="left">
                                    <Typography className="customer-table-headers">
                                    Actions
                                    </Typography>
                                </TableCell> */}
                                </TableRow>
                            </TableHead>

                            <TableBody>
                                {exchangeRates.length > 0 ? (
                                    exchangeRates
                                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                    .map((row) => (
                                        <TableRow key={row.id}>
                                        <TableCell component="th" scope="row">
                                            {editingRowId === row.id ? (
                                            <TextField
                                                name="sourcecurrency"
                                                value={editedData.sourcecurrency}
                                                disabled
                                                onChange={(e) =>
                                                setEditedData({
                                                    ...editedData,
                                                    sourcecurrency: e.target.value,
                                                })
                                                }
                                                size="small"
                                            />
                                            ) : (
                                            row.sourcecurrency
                                            )}
                                        </TableCell>

                                        <TableCell>
                                            {editingRowId === row.id ? (
                                            <TextField
                                                name="destinationcurrency"
                                                value={editedData.destinationcurrency}
                                                disabled
                                                onChange={(e) =>
                                                setEditedData({
                                                    ...editedData,
                                                    destinationcurrency: e.target.value,
                                                })
                                                }
                                                size="small"
                                            />
                                            ) : (
                                            row.destinationcurrency
                                            )}
                                        </TableCell>

                                        <TableCell>
                                            {editingRowId === row.id ? (
                                            <TextField
                                                name="rate"
                                                type="number"
                                                value={editedData.rate}
                                                onChange={(e) =>
                                                setEditedData({
                                                    ...editedData,
                                                    rate: e.target.value,
                                                })
                                                }
                                                size="small"
                                            />
                                            ) : (
                                            row.rate
                                            )}
                                        </TableCell>

                                        <TableCell>
                                            {editingRowId === row.id ? (
                                            <Switch
                                                checked={editedData.active}
                                                onChange={(e) =>
                                                setEditedData({
                                                    ...editedData,
                                                    active: e.target.checked,
                                                })
                                                }
                                            />
                                            ) : row.active ? (
                                            "Yes"
                                            ) : (
                                            "No"
                                            )}
                                        </TableCell>

                                        <TableCell>
                                            {editingRowId === row.id ? (
                                            <Button
                                                variant="contained"
                                                size="small"
                                                color="success"
                                                onClick={() => handleUpdate(row.id)}
                                            >
                                                Update
                                            </Button>
                                            ) : (
                                                <>
                                                    <Button
                                                        variant="outlined"
                                                        size="small"
                                                        onClick={() => startEditing(row)}
                                                    >
                                                        Edit
                                                    </Button>
                                                    <Button
                                                        sx={{ ml:1 }}
                                                        variant="outlined"
                                                        size="small"
                                                        color="secondary"
                                                        onClick={() => handleViewHistory(row)}
                                                    >
                                                        View History
                                                    </Button>
                                                </>
                                            )}
                                        </TableCell>
                                        </TableRow>
                                    ))
                                ) : (
                                    <TableRow>
                                    <TableCell colSpan={5} align="center">
                                        No exchange rates found
                                    </TableCell>
                                    </TableRow>
                                )}
                                </TableBody>
                        </Table>

                        {/* Pagination */}
                        <BaseCustomerTable
                            page={page}
                            onPageChange={handleChangePage}
                            pageNumbers={pageNumbers}
                        />
                    </TableContainer>
                </>
            ) : (
                <>
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            mb: 2,
                        }}
                    >
                        <Typography variant="h6">Exchange Rate History</Typography>
                        <Button variant="outlined" onClick={handleBack}>
                            Back
                        </Button>
                    </Box>

                    <TableContainer component={Paper} sx={{ boxShadow: "none" }}>
                        <Table sx={{ minWidth: 500 }} aria-label="exchange rate history table">
                            <TableHead>
                            <TableRow>
                                <TableCell align="left">
                                <Typography className="customer-table-headers">
                                    Updated On
                                </Typography>
                                </TableCell>
                                <TableCell align="left">
                                <Typography className="customer-table-headers">
                                    Source Currency
                                </Typography>
                                </TableCell>
                                <TableCell align="left">
                                <Typography className="customer-table-headers">
                                    Destination Currency
                                </Typography>
                                </TableCell>
                                <TableCell align="left">
                                <Typography className="customer-table-headers">Rate</Typography>
                                </TableCell>
                                <TableCell align="left">
                                    <Typography className="customer-table-headers">
                                        Updated By UserId
                                    </Typography>
                                </TableCell>
                                <TableCell align="left">
                                    <Typography className="customer-table-headers">
                                        Updated By Username
                                    </Typography>
                                </TableCell>
                            </TableRow>
                            </TableHead>

                            <TableBody>
                            {historyData.length > 0 ? (
                                historyData
                                .slice(
                                    historyPage * historyRowsPerPage,
                                    historyPage * historyRowsPerPage + historyRowsPerPage
                                )
                                .map((item, idx) => (
                                    <TableRow key={idx}>
                                        <TableCell>{item?.recdate}</TableCell>
                                        <TableCell>{item?.sourcecurrency}</TableCell>
                                        <TableCell>{item?.destinationcurrency}</TableCell>
                                        <TableCell>{item?.rate}</TableCell>
                                        <TableCell>{item?.lastupdateby}</TableCell>
                                        <TableCell>{item?.lastupdateemail}</TableCell>
                                    </TableRow>
                                ))
                            ) : (
                                <TableRow>
                                <TableCell colSpan={5} align="center">
                                    No history found
                                </TableCell>
                                </TableRow>
                            )}
                            </TableBody>
                        </Table>

                        {/* -------- Pagination for History Table -------- */}
                        <BaseCustomerTable
                            page={historyPage}
                            onPageChange={(event, newPage) => setHistoryPage(newPage)}
                            pageNumbers={Array.from(
                            { length: Math.ceil(historyData.length / historyRowsPerPage) },
                            (_, index) => index
                            )}
                        />
                        </TableContainer>
                    </>
            )}
        </Box>
    );
}
